import Navbar from "../components/Navbar";
import Trust from "../components/Trust";
import { Footer } from "../components/Footer";

export default function SuccessStories() {
  return (
    <>
      <Navbar />
      <Trust />
      <Footer />
    </>
  );
}